// Define the styles that can't be handled by Tailwind CSS
const dotStyle = {
  animation: 'mercuryTypingAnimation 1.8s infinite ease-in-out',
  backgroundColor: '#f59e0b',
  borderRadius: '50%',
  height: '7px',
  marginRight: '4px',
  width: '7px',
};

const TypingIndicator = ({ className = '' }) => {
  return (
    <>
      <div className={'flex items-center h-4 opacity-50 mt-2 ' + className}>
        <span style={{ ...dotStyle, animationDelay: '200ms' }} />
        <span style={{ ...dotStyle, animationDelay: '300ms' }} />
        <span
          style={{ ...dotStyle, animationDelay: '400ms', marginRight: 0 }}
        />
      </div>
      <style>{styles}</style>
    </>
  );
};

// Keyframes for the animation
const styles = `
  @keyframes mercuryTypingAnimation {
    0% {
      transform: translateY(0px);
      background-color: #f59e0b;
    }
    28% {
      transform: translateY(-7px);
      background-color: #f59e0b91;
    }
    44% {
      transform: translateY(0px);
      background-color: #f59e0b77;
    }
  }
`;

export default TypingIndicator;
